import { __awaiter } from "tslib";
import { postWithProxy } from './proxyAPI';
export const contactDataPointSearch = (searchData) => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield postWithProxy('/api/v2/search', searchData);
    return (data === null || data === void 0 ? void 0 : data.data) || data; // inner data looks like a bug
});
